import { RETRY_PARENT_UPDATES } from './actionCreators';
import { getFailedActionsForParent } from './selectors';

export const createBlendMiddleware =
  (updaters) => (store) => (next) => (action) => {
    updaters
      .filter(({ actionType }) =>
        typeof actionType === 'function'
          ? actionType(action.type, store.getState)
          : actionType === action.type,
      )
      .forEach(({ updater }) => {
        updater(store, action);
      });

    if (action.type === RETRY_PARENT_UPDATES) {
      getFailedActionsForParent(store.getState(), action.payload).forEach(
        (retryAction) => {
          store.dispatch(retryAction);
        },
      );
    }

    next(action);
  };
